/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconAstronaut2 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M7.75 19.5h4a1 1 0 0 1 1 1v1.75a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V20.5a1 1 0 0 1 1-1z" />
        <path d="M18.75 23.25v-3a4.5 4.5 0 0 0-3.239-4.32 1.748 1.748 0 0 1-1.261-1.68v-3a4.5 4.5 0 0 0-9 0v3c0 .778-.514 1.462-1.261 1.679a4.5 4.5 0 0 0-3.239 4.32v3" />
        <path d="M5.25 11.25l1.658-.829a6.352 6.352 0 0 1 5.684 0l1.658.829M5.25 14.25l1.658.829a6.352 6.352 0 0 0 5.684 0l1.658-.829M.75 20.25V13.5A2.25 2.25 0 0 1 3 11.25M18.75 20.25V13.5a2.25 2.25 0 0 0-2.25-2.25M11.25.75v3M9.75 2.25h3M21.75 8.25v3M20.25 9.75h3M18.75.75a3.024 3.024 0 0 1-3 3 3.024 3.024 0 0 1 3 3 3.024 3.024 0 0 1 3-3 3.024 3.024 0 0 1-3-3" />
      </g>
    </svg>
  ),
);
